import { render } from "./vluckydraw.vue?vue&type=template&id=788c9c25&scoped=true"
import script from "./vluckydraw.vue?vue&type=script&lang=js"
export * from "./vluckydraw.vue?vue&type=script&lang=js"

import "./vluckydraw.vue?vue&type=style&index=0&id=788c9c25&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788c9c25"]])

export default __exports__